import pagePath from '@/utils/pagePath'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router'

const GoogleSignupRedirectPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  useEffect(() => {
    if (!token) {
      navigate(pagePath.login, {
        replace: true,
      })
      return
    }
    navigate(`${pagePath.signup}?token=${token}`, {
      replace: true,
    })
  }, [navigate, token])

  return null
}

export default GoogleSignupRedirectPage
